<div class="headerFlexW pr-4 m-3">
  <div class="content-block">
    <p class="bread-crumbs">Inicio</p>
    <h2 class="">Bienvenido {{cdta.companyName}}</h2>
  </div>
</div>
<div class="content-block">
  <div class="dx-card responsive-paddings">
    <div class="flex flex-nowrap flex-space-between">
      <!-- //IZQ -->
      <div class="w-30">
        <h3>Saldo</h3>
        <div class="round-border">
          <div class="icon-cyrcle">
            <i class="fad fa-coins fa-4x brand-color"></i>
          </div>
          <!-- <div class="myBalance">
            <h2 class="txt-center">Próximamente</h2>
          </div> -->
          <div class="myBalance" *ngIf="udta.level!=1">
            <h2 class="txt-center">{{balance?.balance | currency}}</h2>
          </div>
        </div>
      </div>
      <!-- DER  -->
      <div class="w-70">
        <h3>Dispersiones</h3>
        <div class="round-border">
          <div id="chart-demo">
            <dx-chart
                palette="soft"
                [dataSource]="dispersions | chart">
                <dxi-series
                    *ngFor="let energy of energySources"
                    [valueField]="energy.value"
                    [name]="energy.name"
                    color="#01A522">
                </dxi-series>
                <dxo-tooltip
                  [format]="{ style: 'currency', currency: 'USD', useGrouping: true }"
                  [enabled]="true">
                </dxo-tooltip>
                <dxo-crosshair [enabled]="true"
                    color="#949494"
                    [width]="3"
                    dashStyle="dot">
                  <dxo-label [visible]="true">
                    <dxo-format
                      type="currency"
                      [precision]="2">
                    </dxo-format>
                  </dxo-label>
                </dxo-crosshair>
                <dxo-common-series-settings #seriesSettings
                    argumentField="dateScheduled"
                    type='area'
                    [ignoreEmptyPoints]="true">
                </dxo-common-series-settings>
                <dxo-margin [bottom]="20"></dxo-margin>
                <dxi-value-axis [tickInterval]="1">
                  <dxo-label>
                    <dxo-format
                      type="currency"
                      [precision]="2">
                    </dxo-format>
                  </dxo-label>
                </dxi-value-axis>
                <dxo-argument-axis
                  [valueMarginsEnabled]="true"
                  discreteAxisDivisionMode="crossLabels">
                  <dxo-tick [visible]="false"></dxo-tick>
                  <dxo-grid [visible]="false"></dxo-grid>
                  <dxo-label
                    format="shortDate"
                    [customizeText]="customizeText" [visible]="true">
                    <!-- <dxo-format
                      type="date">
                    </dxo-format> -->
                  </dxo-label>
                </dxo-argument-axis>
                <dxo-legend
                    verticalAlignment="bottom"
                    horizontalAlignment="center"
                    itemTextPosition="bottom"
                    [visible]="false">
                </dxo-legend>
                <dxo-title
                    text="Dispersiones">
                    <dxo-subtitle text="(Diario)">
                    </dxo-subtitle>
                </dxo-title>
                <dxo-tooltip [enabled]="true"></dxo-tooltip>
            </dx-chart>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-5">
      <h3>Dispersiones programadas</h3>
        <div class="">
          <dx-data-grid [dataSource]="dispersionsPending" keyExpr="id" [showBorders]="true" class="usersGrid">
            <dxo-load-panel [enabled]="true"></dxo-load-panel>
            <dxi-column dataField="dateCreated" caption="Creada" cellTemplate="dateTemplate" alignment="center">
            </dxi-column>
            <dxi-column dataField="dateScheduled" caption="Fecha programada" cellTemplate="dateTemplate" alignment="center">
            </dxi-column>
            <dxi-column dataField="companyName" caption="Empresa" alignment="center"></dxi-column>
            <dxi-column dataField="status" caption="Status" cellTemplate="statusTemplate" alignment="center">
            </dxi-column>
            <dxi-column dataField="dispersionAmount" caption="Dispersión" dataType="number" format="currency"
              alignment="center">
              <dxo-format type="currency" [precision]="2"></dxo-format>
            </dxi-column>
            <dxo-summary>
              <dxi-total-item column="companyName" summaryType="count">
              </dxi-total-item>
              <dxi-total-item column="dispersionAmount" summaryType="sum" valueFormat="currency">
                <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
              </dxi-total-item>
              <dxi-total-item column="fees" summaryType="sum" valueFormat="currency">
                <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
              </dxi-total-item>
              <dxi-total-item column="granTotal" summaryType="sum" valueFormat="currency">
                <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
              </dxi-total-item>
            </dxo-summary>
            <div *dxTemplate="let d of 'dateTemplate'">
              <div *ngIf="d.value"> {{d.value|numberToDate}}</div>
            </div>
            <div *dxTemplate="let d of 'statusTemplate'">
              <span *ngIf="d.value === 1">Por aprobar</span>
              <span *ngIf="d.value === 2">Aprobada</span>
              <span *ngIf="d.value === 3">Completada</span>
            </div>
          </dx-data-grid>
        </div>
    </div>
    <div class="mt-5">
      <h3>Historial de dispersiones</h3>
      <!-- <div class="round-border mb-5">
        Grafica
      </div> -->
      <div class="">
        <dx-data-grid [dataSource]="dispersionsCompleted" keyExpr="id" [showBorders]="true" class="usersGrid">
          <dxo-load-panel [enabled]="true"></dxo-load-panel>
          <dxo-paging [pageSize]="10"></dxo-paging>
          <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 25, 50, 100]" [showInfo]="true">
          </dxo-pager>
          <!-- <dxi-column dataField="dateCreated" caption="Creada" cellTemplate="dateTemplate" alignment="center">
          </dxi-column> -->
          <dxi-column dataField="dateScheduled" caption="Fecha ejecutada" cellTemplate="dateTemplate" sortOrder="desc" alignment="center">
          </dxi-column>
          <dxi-column dataField="companyName" caption="Empresa" alignment="center"></dxi-column>
          <dxi-column dataField="dispersionAmount" caption="Dispersión" dataType="number" format="currency"
            alignment="center">
            <dxo-format type="currency" [precision]="2"></dxo-format>
          </dxi-column>
          <dxi-column dataField="fees" caption="Comisión" dataType="number" format="currency" alignment="center">
            <dxo-format type="currency" [precision]="2"></dxo-format>
          </dxi-column>
          <dxi-column dataField="tax" caption="IVA" dataType="number" format="currency" alignment="center">
            <dxo-format type="currency" [precision]="2"></dxo-format>
          </dxi-column>
          <dxi-column dataField="granTotal" caption="Total" dataType="number" format="currency" alignment="center">
            <dxo-format type="currency" [precision]="2"></dxo-format>
          </dxi-column>
          <!-- <dxi-column dataField="status" caption="Status" cellTemplate="status" alignment="center"></dxi-column> -->
          <dxo-summary>
            <dxi-total-item column="companyName" summaryType="count"></dxi-total-item>
            <dxi-total-item column="dispersionAmount" summaryType="sum" valueFormat="currency">
              <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
            </dxi-total-item>
            <dxi-total-item column="fees" summaryType="sum" valueFormat="currency">
              <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
            </dxi-total-item>
            <dxi-total-item column="tax" summaryType="sum" valueFormat="currency">
              <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
            </dxi-total-item>
            <dxi-total-item column="granTotal" summaryType="sum" valueFormat="currency">
              <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
            </dxi-total-item>
          </dxo-summary>
          <div *dxTemplate="let d of 'dateTemplate'">
            <div *ngIf="d.value"> {{d.value|numberToDate}}</div>
          </div>
        </dx-data-grid>
      </div>
    </div>
  </div>
</div>